import { useEffect } from "react"
import { useStore } from "../State/Store"

function SetVis() {
  const setVisible = useStore(state => state.setVisible)
  const setFavouritesActive = useStore(state => state.setFavouritesActive)
  const setActiveApt = useStore(state => state.setActiveApt)
  const setActiveFloors = useStore(state => state.setActiveFloors)
  const setActivateBlock = useStore(state => state.setActivateBlock)

  useEffect(() => {
    setVisible && setVisible(true)

    return () => {
      setVisible && setVisible(false)
      setFavouritesActive(false)
      setFavouritesActive(false)
      setActiveApt(null)
      setActiveFloors(null)
      setActivateBlock(null)
    }
  }, [])

  return null
}

export default SetVis
